@let message =
  typeof data.message === "string"
    ? (data.message | translate)
    : (data.message.key | translate: data.message.params);

<div class="content" mat-dialog-content>
  <div [innerHTML]="message"></div>
  @if (data.details) {
    <details class="details">
      <summary>{{ "alertDialog.showDetails" | translate }}</summary>
      <pre>{{ data.details }}</pre>
    </details>
  }
</div>
<div mat-dialog-actions>
  @if (data.type === MessageType.Error) {
    <div style="margin-right: auto">
      <a mat-button (click)="report()">
        {{ "alertDialog.report" | translate }}
      </a>
    </div>
  }
  <button mat-flat-button color="primary" (click)="ok()">{{ "shared.ok" | translate }}</button>
</div>
